import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import { DateRangePicker } from 'components';

import style from '../Filtering.module.scss';

const toLocalFormat = (date) => (date ? date.format('MM/DD/YYYY') : null);
const toExpensesFormat = (date) => (date ? date.format('YYYY-MM-DD') : null);

const FilterByDateRange = ({ params, label, isExpenses }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const startParamValue = params.get('startDate');
  const endParamValue = params.get('endDate');

  const setDateInParams = (date, key) => {
    if (date !== startParamValue && params.get('page')) {
      params.setFew([
        { key: key, value: date },
        { key: 'page', value: '1' }
      ]);
    } else if (date !== startParamValue) {
      params.set(key, date);
    }
  };

  useEffect(() => {
    setDateInParams(isExpenses ? toExpensesFormat(startDate) : toLocalFormat(startDate), 'startDate');
  }, [startDate]);

  useEffect(() => {
    setDateInParams(isExpenses ? toExpensesFormat(endDate) : toLocalFormat(endDate), 'endDate');
  }, [endDate]);

  useEffect(() => {
    if (startParamValue) setStartDate(dayjs(startParamValue));
    if (endParamValue) setEndDate(dayjs(endParamValue));
  }, []);

  return (
    <DateRangePicker
      dateF
      startDate={startDate}
      setStartDate={setStartDate}
      endDate={endDate}
      wrapperStyle={style.wrapper}
      setEndDate={setEndDate}
      label={label}
    />
  );
};

export default FilterByDateRange;
